import React from "react";

import ContentFaleConosco from "components/MI/fale-conosco/Content";
import FAQFaleConosco from "components/MI/fale-conosco/FAQ";
import Navbar from "components/MI/Navbar";
import UserMenu from "components/layout/userMenuNew";

import { faleConoscoTitles } from "../constants/titles";
import { useFaleConoscoPage } from "../hooks/useFaleConoscoPage";
import {
  Body,
  Container,
  Header,
  HeaderInfos,
  HeaderSubtitle,
  HeaderTitle,
} from "../styles";

const FaleConoscoPage = (): JSX.Element => {
  const { page, setPage } = useFaleConoscoPage();

  const pages: Record<string, JSX.Element> = {
    inicio: <ContentFaleConosco setPage={setPage} />,
    "duvidas-frequentes": <FAQFaleConosco setPage={setPage} />,
  };

  const titles = faleConoscoTitles[page as keyof typeof faleConoscoTitles];

  return (
    <Navbar selected="contato">
      <UserMenu />
      <Container>
        <Header>
          <HeaderInfos>
            <HeaderTitle>{titles.title}</HeaderTitle>
            <HeaderSubtitle>{titles.subtitle}</HeaderSubtitle>
          </HeaderInfos>
        </Header>
        <Body>{pages[page]}</Body>
      </Container>
    </Navbar>
  );
};

export default FaleConoscoPage;
